import React from "react";

function SectionTitle({ title }) {
  return (
    <h3 className="font-semibold text-sm uppercase text-gray-700">{title}</h3>
  );
}

export default SectionTitle;
